import clsx from 'clsx';

import type { ButtonProps } from './Button';
import s from './Button.module.scss';
import ButtonOutlined from './ButtonOutlined';

const ButtonOutlinedError = ({ className, ...props }: ButtonProps) => (
  <ButtonOutlined className={clsx(s.outlinedError, className)} {...props} />
);

export default ButtonOutlinedError;
